import { render, staticRenderFns } from "./desk-header.vue?vue&type=template&id=0e764d5a&scoped=true&"
import script from "./desk-header.vue?vue&type=script&lang=js&"
export * from "./desk-header.vue?vue&type=script&lang=js&"
import style0 from "./desk-header.vue?vue&type=style&index=0&id=0e764d5a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e764d5a",
  null
  
)

export default component.exports